var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"course-status",class:_vm.statusClass,attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[(_vm.showLiving)?_c('span',{staticClass:"living-icon"},[_c('span')]):_vm._e(),_c('span',{staticClass:"btn-text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }